var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.427 8l4.279-4.279a1.013 1.013 0 000-1.427 1.012 1.012 0 00-1.426 0L8 6.574l-4.28-4.28a1.013 1.013 0 00-1.427 0 1.015 1.015 0 000 1.427L6.573 8l-4.28 4.279a1.015 1.015 0 000 1.427 1.013 1.013 0 001.427 0L8 9.426l4.28 4.28a1.012 1.012 0 001.426 0 1.013 1.013 0 000-1.427L9.426 8z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cd7fcb43cbfdd94d0790f897eaaeaff7.svg";
export { ForwardRef as ReactComponent };